import ErrorModel from '../../../../vendor_core/core/src/model/ErrorModel';
import { ICondition } from '../../../../vendor_core/core/src/states/State';
import SpinModel from '../../../core/src/model/SpinModel';
import VendorModel from '../../model/VendorModel';

export default class HasFreeGamesExpiredCondition implements ICondition {
    check(): boolean {
        if (!SpinModel.inFreegames() && VendorModel.hasFreeGamesExpiredDuringFreespins) {
            // This is the case, where the user refreshes the page right after the free games expired,
            // and the free spins are not finished yet. We must inform the user,
            // that everything was paid to their account.
            return true;
        }
        
        let freeGamesExpired: boolean = false;

        // We should allow the player to play all the freespins
        if (SpinModel.inFreegames() && !SpinModel.isInFreespins()) {
            if (ErrorModel.errorCode === 560) {
                freeGamesExpired = true;
                VendorModel.hasFreeGamesExpired = true;
                ErrorModel.cleanUp();
            } else if (VendorModel.hasFreeGamesExpiredDuringFreespins) {
                // A temp solution, until relax start raising 560 again.
                freeGamesExpired = true;
                VendorModel.hasFreeGamesExpired = true;
            }
        } else {
            freeGamesExpired = false;
        }

        return freeGamesExpired
    }
}
